<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <div class="row">
                    <div class="chat-bottom-section-web width-full float-l">
                        <div class="chat-web-left-section col-12 col-sm-12 col-md-12 col-lg-4 col-lg-4 float-l"> <!--left section-->
                            <div class="row">
                                <div id="snackbar">
                                    <span>Chat archived
                                        <a  style="color: blue; cursor: pointer" v-on:click="undoArchiveChat()">UNDO</a>
                                    </span>
                                </div>
                                <div class="header-section col-12 float-l bgcolor-cfe3ee"> <!--mobile header section-->

                                    <div class="user-customer-title float-l colpie-78">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link"  data-toggle="tab" href="#customer" v-on:click="tabClick('user')" role="tab">
                                                    <div style="float:left;">Users </div>
                                                    <template v-if="userCounter">
                                                        <div class="chat-counter">
                                                            {{userCounter}}
                                                        </div>
                                                        <!-- <p v-if="userCounter > 0" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{userCounter}} </p> -->
                                                    </template>
                                                </a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link active" id="customerTab" data-toggle="tab" href="#admin" v-on:click="tabClick('customer')" role="tab">
                                                    <div style="float:left;">Customers </div>
                                                    <template v-if="customerCounter">
                                                        <div class="chat-counter">
                                                            {{customerCounter}}
                                                        </div>
                                                        <!-- <div v-if="customerCounter > 0" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{customerCounter}} </div> -->
                                                    </template>
                                                </a>
                                            </li>
                                        </ul><!-- Tab panes -->
                                    </div>

                                    <div class="right-header-section float-r">
                                        <div class="search-bar-right">
                                            <div class="searchbox">
                                                <input type="search" @input="searchAPI()" v-model="searchText" placeholder="Search......" name="search" class="searchbox-input" required>
                                                <!-- <input type="submit" class="searchbox-submit" value=""> -->
                                                <!-- {{searchOpen}} -->
                                                <a v-if="!searchOpen" href="javascript:void(0)" v-on:click="searchBoxClose()" class="searchbox-icon">
                                                    <img src="/static/images/search-close.png">
                                                </a>
                                                <span v-if="searchOpen" class="searchbox-icon" v-on:click="searchBoxOpen()"> <i class="hi-icon icon-chatmagnifying-glass"></i> </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="menu-right-header float-r"> <!--header menu section-->
                                        <div class="nc-chat-right-dropdown">
                                            <div class="dropdown">

                                                <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                </button>

                                                <ul class="dropdown-menu">
                                                    <!-- <li class="username-status">
                                                        <a href="javascript:void(0)" onclick="$('#myModal-1').modal('show')">{{Auth::user()->name}} <span id="user_menu_status"  class="{{ strtolower(Auth::user()->status) }}"> </span> </a>  </li> -->
                                                    <p class="user-name color-f5911e heading-text-14 line-height-20 font-benton-bold float-l width-full">
                                                        <span v-if="status == 'Online' || status == 'online'" class="bgcolor-5cbb55 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                                        <span v-else class="bgcolor-ff3636 p_5 pull-left absolute l-15 t-5 radius-100"></span>
                                                        {{userName}}
                                                    </p>
                                                    <li> <router-link v-bind:to="{name: 'SiteList'}"> My Sites <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'UserList'}"> User List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'CustomerList'}"> Customer List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'ArchivedChat'}"> Archived Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li v-if="currentEnvironment && cantAccessPage === true"> <router-link v-bind:to="{name: 'MailList'}"> Mail List <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li v-if="cantAccessPage === true"> <router-link v-bind:to="{name: 'ListSectionSchedulerTime'}"> Schedule Section <span> <i class="fa fa-angle-right custom" ></i> </span> </router-link> </li>
                                                    <li class="user-status-edit" v-if="status == 'Online' || status == 'online'">
                                                        <a href="javascript:void(0)" v-on:click="chagneStatus('offline')"> Offline
                                                            <span>
                                                                <i class="fa fa-angle-right custom"></i>
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="user-status-edit" v-else>
                                                        <a href="javascript:void(0)" v-on:click="chagneStatus('online')"> Online
                                                            <span>
                                                                <i class="fa fa-angle-right custom"></i>
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li> <a v-on:click.prevent="logoutMobileView" href="javascript:void(0)"> Sign Out <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                    <!-- <li v-if="!isWebView" class="version">
                                                        <a href="javascript:void(0);">Version: {{Auth::user()->app_version}}</a>
                                                    </li> -->
                                                </ul>
                                            </div>
                                        </div>
                                    </div> <!--header menu section-->

                                </div> <!--mobile header section-->

                                <!--Start listing section-->
                                <div class="chat-btm-section-main width-full float-l">
                                    <div class="tab-content float-l width-full">

                                        <div class="tab-pane active customer-chat-btm float-l width-full" id="customer" role="tabpanel"> <!--Users tab-->
                                            <template v-if="userArray && userArray.length > 0">
                                                <template v-for="(user, userIndex) in userArray">
                                                    <!-- {{user}} -->
                                                    <template v-if="user.id != logingId">
                                                        <div class="chat-listing-user-section" :key="userIndex">
                                                            <div v-if="!isMobileView" :key="userIndex" class="chat-listing-section-main pull-left width-full" v-on:click="getUserChatById(user.id, user.name, user.sections, user.roleName, user.email, user.strSectionRole)">
                                                                <div class="pull-left width-full p-15 relative">

                                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">{{user.email | filtersGetName(user.name)}}
                                                                        <span v-if="user.status == 'online'" class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                        <span v-else class="bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                    </span>

                                                                    <div class="right-listing-detail pl_65 pull-left width-full pr_90">                         
                                                                        <h3 class="color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3">{{user.name}}</h3>
                                                                        <template v-for="(userRole, userIndex1) in user.roles">
                                                                            <span :key="userIndex1" class="color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{userRole}} </span>
                                                                        </template>
                                                                        <p v-if="user.unReadMessageCount > 0 && user.toId == logingId" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{user.unReadMessageCount}} </p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0)" class="float-l" v-on:click.prevent="makeArchivedChat(user.id, 'user')"> <i class="archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                        </div>
                                                        <div class="chat-listing-user-section-mobile" :key="'mobile'+userIndex">
                                                            <div v-if="isMobileView" :key="'mobile'+userIndex" class="chat-listing-section-main pull-left width-full" v-on:click="gotoChatDetailsPage(user.id)">
                                                                <div class="pull-left width-full p-15 relative">

                                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">{{user.email | filtersGetName(user.name)}}
                                                                        <span v-if="user.status == 'online'" class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                        <span v-else class="bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                    </span>

                                                                    <div class="right-listing-detail pl_65 pull-left width-full pr_90">                         
                                                                        <h3 class="color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3">{{user.name | filterCamelCase}}</h3>
                                                                        <template v-for="(userRole, userIndex1) in user.roles">
                                                                            <span :key="'mobile'+userIndex1" class="color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{userRole}} </span>
                                                                        </template>
                                                                        <a href="javascript:void(0)" v-on:click="gotoChatDetailsPage(user.id)" class="float-l"> <i class="view-detail-icon fa fa-angle-right absolute r-8 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                                        <p v-if="user.unReadMessageCount > 0 && user.toId == logingId" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{user.unReadMessageCount}} </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <a href="javascript:void(0)" class="float-l user-mobile-archived-chat" v-on:click.prevent="makeArchivedChat(user.id, 'user')"> <i class="archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                        </div>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="requestComplete">
                                                    <div class="no-user-found" v-if="isMobileView">
                                                        No User Found!
                                                    </div>
                                                    <div class="no-user-found" v-else>
                                                        No User Found!
                                                    </div>
                                                </template>
                                            </template>
                                        </div> <!--Userd tab-->
                                            
                                        <div class="tab-pane customer-chat-btm float-l width-full" id="admin" role="tabpanel"> <!--Customers tab-->
                                            <template v-if="customerArray && customerArray.length > 0">
                                                <template v-for="(customer, customerIndex) in customerArray">
                                                    <!-- {{customer}} -->
                                                    <div class="chat-listing-user-section" :key="customerIndex">
                                                        <div v-if="!isMobileView" class="chat-listing-section-main pull-left width-full" v-on:click="getUserChatById(customer.id, customer.name, customer.sections, customer.roleName, customer.email, '')">
                                                            <div class="pull-left width-full p-15 relative">                        
                                                                <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">{{customer.email | filtersGetName(customer.name)}}
                                                                    <span v-if="customer.status == 'online'" class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                    <span v-else class="bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                </span>

                                                                <div class="right-listing-detail pl_65 pull-left width-full pr_90">                      
                                                                    <h3 class="color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3">{{customer.name | filterCamelCase}}</h3>
                                                                    <!-- <span class="color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{customer.sections | filterCamelCase}} ({{customer.roleName | filterCamelCase}}) </span> -->
                                                                    <!-- {{customer.roles}} -->
                                                                    <template v-for="(customerRole, customerIndex1) in customer.roles">
                                                                        <span :key="customerIndex1" class="color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{customerRole}} </span>
                                                                    </template>
                                                                    <p v-if="customer.unReadMessageCount > 0 && customer.toId == logingId" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{customer.unReadMessageCount}} </p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <a href="javascript:void(0)" class="float-l" v-on:click="makeArchivedChat(customer.id, 'customer')"> <i class="archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                    </div>
                                                    <div class="chat-listing-user-section-mobile" :key="'mobile'+customerIndex">
                                                        <div v-if="isMobileView" :key="'mobile'+customerIndex" class="chat-listing-section-main pull-left width-full" v-on:click="gotoChatDetailsPage(customer.id)">
                                                            <div class="pull-left width-full p-15 relative">                        
                                                                <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">{{customer.email | filtersGetName(customer.name)}}
                                                                    <span v-if="customer.status == 'online'" class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                    <span v-else class="bgcolor-ff3636 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                                </span>

                                                                <div class="right-listing-detail pl_65 pull-left width-full pr_90">                      
                                                                    <h3 class="color-333333 font-benton-bold heading-text-16 line-height-20 float-l width-full mb_3">{{customer.name | filterCamelCase}}</h3>
                                                                    <!-- <span class="color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{customer.sections | filterCamelCase}} ({{customer.roleName | filterCamelCase}}) </span> -->
                                                                    <template v-for="(customerRole, customerIndex1) in customer.roles">
                                                                        <span :key="customerIndex1" class="color-888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{customerRole}} </span>
                                                                    </template>
                                                                    <a href="javascript:void(0)" v-on:click="gotoChatDetailsPage(customer.id)" class="float-l"> <i class="view-detail-icon fa fa-angle-right absolute r-8 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                                    <p v-if="customer.unReadMessageCount > 0 && customer.toId == logingId" class="chat-unread-message float-l bgcolor-5cbb55 radius-100 center absolute r-60 t-10 b-10 mr-auto color-white heading-text-12"> {{customer.unReadMessageCount}} </p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <a href="javascript:void(0)" class="float-l user-mobile-archived-chat" v-on:click.prevent="makeArchivedChat(customer.id, 'customer')"> <i class="archive-chat-icon hi-icon icon-chatdownload absolute r-30 t-0 b-0 mr-auto bold color-878787"></i> </a>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="requestComplete">
                                                    <div class="no-user-found" v-if="isMobileView">
                                                        No Customer Found!
                                                    </div>
                                                    <div class="no-user-found" v-else>
                                                        No Customer Found!
                                                    </div>
                                                </template>
                                            </template>
                                        </div> <!--Customers tab-->
                                    </div>

                                    <!--End listing section-->
                                </div>
                            </div>
                        </div> <!--left section-->

                        <div class="chat-web-right-section col-12 col-sm-12 col-md-12 col-lg-8 col-lg-8 float-l" v-if="clickChatFlag"> <!--right section-->
                            <div class="row">

                                <div class="header-section col-12 float-l bgcolor-cfe3ee"> <!--header section-->
                                    <div class="back-btn-chat float-l">
                                        <a href="javascript:void(0)"> <i class="hi-icon icon-chatback"></i> </a>
                                    </div>

                                    <div class="customer-name float-l colpie-87">
                                        <p  class="user-avtar-img float-l font-roboto-bold heading-text-14 line-height-16 bgcolor-d7b081 color-white"> {{email | filtersGetName(name)}} </p>

                                        <p v-on:click="toggleCustomerDetailsDiv()" class="color-231f20 font-roboto-bold heading-text-16 line-height-20 agent-customer-name float-l width-full pt_1 pl_82 mb_0">{{name | filterCamelCase}}
                                            <!-- <span class="color-58595b font-benton-medium heading-text-11 line-height-15 float-l width-full pt_2"> {{section | filterCamelCase}} ({{role | filterCamelCase}}) </span> -->
                                            <span class="color-58595b font-benton-medium heading-text-11 line-height-15 float-l width-full pt_2"> {{strSectionRole}} </span>
                                        </p>
                                    </div>

                                    <div v-if="role == 'guest' || role == 'Guest'" class="hideShowDiv customer-name float-l colpie-87">
                                        <ul class="list-group">
                                            <li class="list-group-item"><i class="fa fa-user"></i> {{customerDetails.name}}</li>
                                            <li class="list-group-item"><i class="fa fa-envelope"></i> {{customerDetails.email}}</li>
                                            <li class="list-group-item"><i class="fa fa-phone-square"></i> {{customerDetails.phone}}</li>
                                            <template v-if="customerDetails.dealership_location != ''">
                                                <li class="list-group-item"><i class="fa fa-map-marker"></i> {{customerDetails.dealership_location}}</li>
                                            </template>
                                            <li class="list-group-item"><i class="fa fa-book"></i> {{customerDetails.subject}}</li>
                                        </ul>
                                    </div>

                                    <div class="right-header-btn float-l" v-if="role == 'guest' || role == 'Guest'">
                                        <ul class="float-l width-full">
                                            <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal1"> <span> <i class="hi-icon icon-chatmail center width-full"></i> </span> Email Chat </a> </li>
                                            <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal"> <span> <i class="hi-icon icon-chatsend center width-full"></i> </span> Forward </a> </li>
                                            <li> <a href="javascript:void(0)" v-on:click="sendMessage('EndChat')"> <span> <i class="hi-icon icon-chatend-chat center width-full"></i> </span> End Chat </a> </li>
                                        </ul>
                                    </div>

                                    <ul class="dropdown-menu-profile middle-chat-query-section">
                                        <li> <p> <span> <i class="fa fa-envelope-o"></i> </span>  user@gmail.com </p> </li>
                                        <li> <p class="phone-number-sec"> <span> <i class="fa fa-phone"></i> </span>  1234567890 </p> </li>
                                        <li class="query-message"> <p class="query-section"> <span> <i style="font-weight:bold;" class='hi-icon icon-chatoval-speech-bubble'></i> </span> Testing message subject </p></li>
                                    </ul>

                                    <div class="menu-right-header float-r"> <!--header menu section-->
                                        <div class="nc-chat-right-dropdown">
                                            <div class="dropdown">

                                                <button class="more-btn btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                    <span class="more-dot"></span>
                                                </button>

                                                <ul class="dropdown-menu">
                                                    <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal1"> Email Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                    <li> <a href="javascript:void(0)" data-toggle="modal" data-target="#basicModal"> Forward Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                    <li> <a href="javascript:void(0)" v-on:click="sendMessage('EndChat')"> End Chat <span> <i class="fa fa-angle-right custom" ></i> </span> </a> </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> <!--header menu section-->
                                </div> <!--header section-->

                                <div v-show="fileUploaded" class="chat-btm-section-main chat-listing-main-mobile width-full float-l">
                                    <form>
                                    <input type="file" @change="handleFiles" multiple ref="fileInput" style="display: none">
                                    <!-- <button type="submit">Upload</button> -->
                                    </form>
                                    <div v-if="filesPreview" v-for="(file, index) in filesPreview">
                                    <h3>File Preview:</h3>
                                    <img v-if="isImage(file.type)" :src="file.src" alt="File Preview" style="max-width: 200px;">
                                    <iframe v-if="isPdf(file.type)" :src="file.src" style="width: 60%; height: 200px;" frameborder="0"></iframe>
                                    <div v-else>File Name: {{ file.name }}</div>
                                    <button @click="removeFile(index)" class="remove-button">
                                    <i class="fas fa-times"></i> Remove
                                    </button>
                                    </div>
                                    <form class="send-message-form-class">
                                    <div class="btm-chat-textarea float-l col-12">
                                        <textarea id="msgTextArear" @input="typingEvent()" v-model="messageData" type="text" placeholder="Type your message here..." class="form-control" name="message"></textarea>
                                        <div class="help is-danger">{{message_text_error_msg}}</div>
                                        <div class="send-message-btn float-l">
                                            <a id="sendMessage" href="javascript:void(0)" v-on:click.prevent="sendMessage('Chat')"> <i class="hi-icon icon-chatplay-button"></i> </a>
                                        </div>
                                        
                                    </div>                            
                                </form>
                                </div>
                                <div v-show="!fileUploaded"
                                    id="dropZone"
                                    class="drop-zone width-full custom-des"
                                    @dragover.prevent="dragOver"
                                    @dragleave="dragLeave"
                                    @drop="drop"
                                >
                                        
                                <div class="chat-btm-section-main chat-listing-main-mobile width-full float-l message-height">
                                    <div class="chat-detail-main col-12 float-l">
                                        <template v-if="messageArray && messageArray.length > 0" v-for="message in messageArray">

                                            <div class="user-chat-main colpie-85 float-l" v-if="message.fromId != logingId"> <!--user chat-->
                                                <div class="user-img float-l">
                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white">
                                                        {{email | filtersGetName(name)}}
                                                    </span>
                                                    <!--<img src="/static/images/user-img.jpg" alt="User Name">-->
                                                </div>

                                                <div class="user-massage float-l width-full">
                                                    <p class="message-content color-333333 heading-text-14 line-height-20 float-l bgcolor-eff1f1 font-text-regular-benton radius-5 pt_10 p_12 mb_0" v-html="message.message"> </p>
                                                    <p class="date color-888888 heading-text-11 line-height-16 float-l width-full font-text-regular-benton mb_0 pt_5 pl_12">{{message.created_date | filterDate}}</p>
                                                </div>
                                            </div> <!--user chat-->

                                            <div class="admin-chat-main colpie-82 float-r" v-else> <!--admin chat-->
                                                <div class="user-massage float-r width-full">
                                                    <p class="message-content color-333333 heading-text-14 line-height-20 float-r bgcolor-d6eef5 font-text-regular-benton radius-5 pt_10 p_12 mb_0" v-html="message.message"></p>
                                                    <p class="date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12">{{message.created_date | filterDate}}</p>
                                                    <p v-if="message.isFailed" class="message-failed date color-888888 heading-text-11 line-height-16 float-r right width-full font-text-regular-benton mb_0 pt_5 pr_12">Message Sending Failed</p>
                                                </div>
                                            </div> <!--admin chat-->

                                            
                                        </template>

                                        <div class="message-typing float-r width-full" v-if="isHideType">
                                            <div class="admin-typing colpie-82 float-l">
                                                <div class="tiblock float-l">
                                                    <div class="tidot"></div>
                                                    <div class="tidot"></div>
                                                    <div class="tidot"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <form class="send-message-form-class">
                                    <div class="btm-chat-textarea float-l col-12">
                                        <textarea id="msgTextArear" @input="typingEvent()" v-model="messageData" type="text" placeholder="Type your message here..." class="form-control" name="message"></textarea>
                                        <div class="help is-danger">{{message_text_error_msg}}</div>
                                        <div class="send-message-btn float-l">
                                            <a id="sendMessage" href="javascript:void(0)" v-on:click.prevent="triggerFileInput"> <i class="fa fa-paperclip"></i> </a>
                                            <a id="sendMessage" href="javascript:void(0)" v-on:click.prevent="sendMessage('Chat')"> <i class="hi-icon icon-chatplay-button"></i> </a>
                                        </div>
                                        
                                    </div>                            
                                </form>
                            </div>
                            <input type="file" ref="fileInput"  @click="triggerFileInput" multiple style="display: none;" @change="handleFiles">

                            </div>
                        </div> <!--right section-->
                    </div>
                </div>
            </div> 
        </div>
        <!--middle middle section-->

        <div class="modal fade forward-chat-modal" id="basicModal" tabindex="-1" role="dialog" aria-labelledby="basicModal" aria-hidden="true"> <!--forward modal popup--> 
            <div class="modal-dialog">

                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title" id="myModalLabel">Forward Message To</h4>
                        <div class="nc-search">
                            <div class="input-group stylish-input-group">
                                <input type="text" class="form-control fName" @input="searchAPI('forwardChat')" v-model="searchText" placeholder="Search" id="forName">
                                <span class="input-group-addon">
                                </span>
                            </div>
                        </div>
                    </div>
                    
                    <template>
                        <div class="modal-body forward-chat-main float-l width-full p_0" v-if="userArray && userArray.length > 0">
                            <!-- {{user}} -->
                            <div  v-for="(user, index) in userArray" :key="index">
                                <template v-if="user.roleName != '' && user.sections != ''">
                                    <template v-if="user.id != logingId">
                                        <div class="chat-listing-section-main chat-forward-section pull-left width-full">
                                            <div class="pull-left width-full p-15 relative">
                                                <template v-if="user.status == 'online'">
                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"> {{user.email | filtersGetName(user.name)}}
                                                        <span class="bgcolor-5cbb55 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <span class="chat-user-name font-benton-bold heading-text-14 line-height-14 radius-100 bgcolor-71c1c5 bold absolute color-white"> {{user.email | filtersGetName(user.name)}}
                                                        <span class="bgcolor-dc3545 border-white p_5 pull-left absolute r-1 t-1 radius-100"></span>
                                                    </span>
                                                </template>
                                                <div class="right-listing-detail pl_65 pull-left width-full pr_35 custom-checkbox">
                                                    <h3 class="color-333333 font-benton-bold heading-text-15 line-height-19 float-l width-full mb_3"> {{user.roleName | filterCamelCase}}({{user.email}})</h3>
                                                    <span class="color-8888888 font-benton-medium heading-text-12 line-height-16 float-l width-full"> {{user.sections | filterCamelCase}} </span>

                                                    <div class="radiobutton">
                                                        <label class="custom-radio-container">
                                                            <template v-if="user.status == 'offline'">
                                                                <input v-model="radioBtnId" type="radio" name="chat" :value="user.id" disabled>
                                                            </template>
                                                            <template v-else>
                                                                <input v-model="radioBtnId" type="radio" name="chat" :value="user.id">
                                                            </template>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </template>

                    <div class="chat-forward-btm float-l width-full bgcolor-eff1f1 relative">         
                        <!-- :id="chatWindow.senderid" :data-userName="chatWindow.name" v-on:click="forwardMessage"               -->
                        <a class="nc-forward-chat-send" href="javascript:void(0);"  v-on:click="forwardMessage()">
                            <i class="hi-icon icon-chatright-arrow"></i> <br/>
                            <span>Forward</span>
                        </a>
                    </div>

                </div>
            </div>
        </div>
        <!-- forward modal popup  -->

        <div class="modal fade forward-chat-modal email-chat-modal" id="basicModal1" tabindex="-1" role="dialog" aria-labelledby="basicModal1" aria-hidden="true"> <!--Email chat modal popup--> 
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title" id="myModalLabel">Email Chat To</h4>
                    </div>

                    <div class="modal-body email-chat-main float-l width-full p_0">
                        <div class="form-group float-l width-full p_15">
                            <input v-validate="'required|email'" type="email" v-model="emailChat" name="email" placeholder="Your email address here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email address here'" class="form-control custom-select">
                            <!-- <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span> -->
                            <div class="help is-danger">{{emailChat_error_msg}}</div>
                        </div>
                    </div>

                    <div class="chat-forward-btm float-l width-full relative pl_15 pr_15">                                
                        <!-- <a class="nc-forward-chat-send" href="javascript:void(0);" :id="chatWindow.senderid" :data-userName="chatWindow.name" v-on:click="forwardMessage">
                            <i class="hi-icon icon-chatright-arrow"></i> <br/>
                            <span>Send</span>
                        </a> -->
                        <button type="button" class="btn btn-primary internal-large-btn float-l mr_20" v-on:click.prevent="sendChatEmail()">
                            <span class="gradient"></span> Send
                        </button>
                    </div>

                </div>
            </div>
        </div> <!--Email chat modal popup-->

        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    var self;
    Vue.component("app-footer", Footer);
    export default {
        name: 'ChatList',
        mixins: [commonMixins],
        data () {
            return {
                selectedFiless: [],
                filesPreview: [],
                fileUploaded:false,
                fileType: '',
                cantAccessPage: true,
                userArray: [],
                customerArray: [],
                messageArray: [],
                logingId: 0,
                toId: 0,
                clickChatFlag: false,
                name: "",
                section: "",
                role: "",
                email: "",
                strSectionRole: "",
                messageData: "",
                userName: "",
                status: '',
                chatWindow: false,
                pusher: '',
                isHideType: false,
                typeAPICallFlag: true,
                emailChat: '',
                emailChat_error_msg: '',
                radioBtnId: 0,
                message_text_error_msg: '',
                searchText: '',
                searchTab: 'customer',
                isMobileView: false,
                requestComplete: false,
                userCounter: 0,
                customerCounter: 0,
                searchOpen: true,
                profileColor: "",
                channel: null,
                timezone: '',
                sendFromThisSide : false,
                unArchiveChatId : 0,
                lastMessage: "",
                customerDetails : { name : "", email : "", phone : "", subject : "", dealership_location: ""},
                uuid : "",
            }
        },
        watch : {
            messageData : function(val) {
                var self = this;
                self.typingEvent();
            }
        },
        beforeMount: function () {
            self = this;
        },
        mounted: function() {
            var self = this;
            //self.$store.dispatch('loadPusherObj');
            self.pusher = self.$pusher;

            $(document).on('keypress',function(e) {
                if(e.which == 13) {
                    e.preventDefault();
                    self.sendMessage('Chat');
                    // $('#sendMessage').click();\
                }
            });

            $('#admin').addClass('active');
            $('#customer').removeClass('active');

            
            EventBus.$emit("headerMobileView", 'Chat List');

            self.loadCustomer();
            self.loadUser();
            self.getPermissions();

            self.broadCastStatusChannel();
            self.broadCast();
            self.broadCastUserRegisterChannel();
            self.broadCastForwardChat();

            self.mobileResizeViewChatListPage();
            window.onresize = function() {
                self.mobileResizeViewChatListPage();
            };
            // self.loadUser();
            // self.loadCustomer();
            self.deselectRadioButtonOnOpenForwardChatModel();

        },
        filters: {
            filtersGetName(value, value2) {

                let name1 = value2.split(" ");
                if(name1[1] && name1[1] != '') {
                    let getName = name1[0].charAt(0) + name1[1].charAt(0);
                    return getName.toUpperCase();
                }
                if(value) {
                    let name = value.charAt(0);
                    let splitData = value.split("@");
                    name += splitData[1].charAt(0);
                    return name.toUpperCase();
                }
            },
            filterCamelCase(data) {

                if (data && data != "") {
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return data;
                }
                
            }, 
            filterDate(date) {
                if (date) {
                    var splitDate = date.split(",");
                    return splitDate[1];
                } else {
                    return '';
                }
            }
        },
        watch : {
            /* toId : function (newValue, oldValue) {
                var self = this;
                // self.channel.unbind('client-send-typing-event'+ oldValue + self.logingId);
                self.channel.bind('client-send-typing-event'+ newValue + self.logingId, function(data) {
                    self.isHideType = true;
                    setTimeout(function() {
                        self.isHideType = false;
                    }, 3000);
                });
            } */
        },

        created() {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            self.status = localStorage.getItem('status');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.logingId = userJson["id"];
                self.userName = userJson['name'];
                self.timezone = userJson["timezone"];
            }
            self.channel = self.$pusher.subscribe('private-chat');
            /*self.channel.bind('client-send-typing-event'+ self.toId + self.logingId, function(data) {
                self.isHideType = true;
                setTimeout(function() {
                    self.isHideType = false;
                }, 3000);
            });*/
        },
        methods: {
            triggerFileInput() {
                this.$refs.fileInput.click();
                this.fileUploaded=true;
            },
            // Handle file selection or drop
            handleFiles(files) {
                var uploadedFiles = files;
                if (files.target != undefined && files.target.files ){
                    this.selectedFiles = Array.from(files.target.files);
                    var uploadedFiles = files.target.files;
                }else{
                    this.selectedFiles = files;
                }

                uploadedFiles.forEach(file => {
                    const fileSizeInMB = file.size / (1024 * 1024); // File size in MB
                    const fileType = file.type;
                    const maxFileSizeMB = 3; // Maximum file size in MB
                    const reader = new FileReader();
                    if (fileSizeInMB > maxFileSizeMB) {
                    // Display placeholder message for large files
                        this.filesPreview.push({
                            type: 'Preview',
                            name: file.name,
                            src: 'File size exceeds 3 MB. Preview not available.'
                        });
                        return; // Skip further processing for large files
                    }
                    reader.onload = (e) => {
                        const fileType = file.type;
                        if (fileType.startsWith('image/') || fileType === 'application/pdf') {
                            // Handle images and PDFs
                            this.filesPreview.push({
                                type: fileType,
                                src: e.target.result,
                                name:file.name
                            });
                        } else {
                            this.filesPreview.push({
                                type: fileType,
                                name:file.name
                            });
                        }
                    };
                    if (file.type.startsWith('image/') || file.type === 'application/pdf') {
                        reader.readAsDataURL(file);
                    }else if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel') {
                        reader.readAsBinaryString(file); // Read as binary string for Excel files
                    } else {
                        reader.readAsText(file);
                    }
                });
            },
            isImage(type) {
                return type.startsWith('image/');
            },
            isPdf(type) {
                return type.startsWith('application/pdf');
            },
            // Check if the file is a text file
            isTextFile(type) {
                return type === 'text/plain';
            },
            // removeFile() {
            //     this.selectedFiles = null;
            //     this.filesPreview = null;
            //     this.fileType = '';
            //     this.$refs.fileInput.value = ''; // Clear the file input
                
            // },
            removeFile(index) {
                console.log(this.selectedFiles);
                this.filesPreview.splice(index, 1);
                this.selectedFiles.splice(index,1);
                this.$refs.fileInput.value = ''
                if (this.selectedFiles == undefined || !this.selectedFiles.length){
                    this.fileUploaded = false;
                }
            },
            // Drag over event
            dragOver(event) {
                event.target.classList.add('dragover');
            },
            // Drag leave event
            dragLeave(event) {
                event.target.classList.remove('dragover');
            },
            // Drop event
            drop(event) {
                event.preventDefault();
                event.target.classList.remove('dragover')
                const files = Array.from(event.dataTransfer.files);
                this.handleFiles(files);
                // event.target.classList.remove('dragover');
                this.fileUploaded = true;
                // this.handleFiles(event);
            },
            
            
            activaTab : function(tab) {
                // alert(tab);
                self.$nextTick(() => {
                    setTimeout(function() {
                        $('.nav-tabs a[href="#' + tab + '"]').tab('show');
                    }, 100);
                });
            },
            toggleCustomerDetailsDiv : function() {
                $(".hideShowDiv").toggle();
            },
            broadCastPrivateChannel: function() {
                var self = this;
                // self.channel.unbind('client-send-typing-event'+ oldValue + self.logingId);
                self.channel.bind('client-send-typing-event'+ self.toId + self.logingId, function(data) {
                    self.isHideType = true;
                    setTimeout(function() {
                        self.isHideType = false;
                    }, 3000);
                });
            },
            openChatScreenFromNotification : function() {
                var path = window.location.href;
                var segments = path.split("?");

                if (segments[1]) {
                    history.replaceState(null, '', segments[0]);
                    var fromID = segments[1];
                    let name, section, role, toId, email, strSectionRole;
                    setTimeout(function () {
                        var resultUser = self.userArray;
                        for (var i=0; i<resultUser.length; i++) {
                            if (resultUser[i].id == fromID) {
                                name = resultUser[i].name;
                                section = resultUser[i].sections;
                                role = resultUser[i].roleName;
                                toId = resultUser[i].id;
                                email = resultUser[i].email;
                                strSectionRole = resultUser[i].strSectionRole;

                                if (self.isMobileView) {
                                    self.gotoChatDetailsPage(toId);
                                } else {
                                    self.getUserChatById(toId, name, section, role, email, strSectionRole);
                                }
                            }
                        }


                        var resultCustomer = self.customerArray;
                        for (var i=0; i<resultCustomer.length; i++) {
                            if (resultCustomer[i].id == fromID) {
                                name = resultCustomer[i].name;
                                section = resultCustomer[i].sections;
                                role = resultCustomer[i].roleName;
                                toId = resultCustomer[i].id;
                                email = resultCustomer[i].email;

                                if (self.isMobileView) {
                                    self.gotoChatDetailsPage(toId);
                                } else {
                                    self.getUserChatById(toId, name, section, role, email, '');
                                }
                            }
                        }

                        if (resultCustomer.length > 0) {
                            $('#userTab').closest('li.nav-item').find('.nav-link').removeClass('active');
                            $('#customerTab').closest('li.nav-item').find('.nav-link').addClass('active');
                            $(document).ready(function(){
                                activaTab('admin');
                            });
                        } else if (resultUser.length > 0) {
                            $('#userTab').closest('li.nav-item').find('.nav-link').addClass('active');
                            $('#customerTab').closest('li.nav-item').find('.nav-link').removeClass('active');
                            $(document).ready(function(){
                                activaTab('customer');
                            });
                        }
                    }, 1000);
                }

                function activaTab(tab){
                    $('.nav-tabs a[href="#' + tab + '"]').tab('show');
                };
            },
            deselectRadioButtonOnOpenForwardChatModel : function () {
                $('#basicModal').on('show.bs.modal', function(event) {
                    var button = $(event.relatedTarget); // Button that triggered the modal
                    $('input[name="chat"]:checked').prop('checked', false); //I'm doing this coz every time new popup opens redio button will be reset to none. If you don't need to do this remove this line
                });
            },
            ScrollToBottom : function () {

            },
            trigger(eventName, message) {
                var self = this;
                setTimeout(function() {
                  if ((self.messageData.length - self.lastMessage.length) > 5) {
                    self.lastMessage = self.messageData;
                    self.channel.trigger(eventName, { message });
                  }
                }, 1000);
            },
            typingEvent() {
                var self = this;
                self.trigger('client-send-typing-event'+ self.logingId + self.toId, 'Type!');
            },
            searchBoxOpen: function() {
                
                var submitIcon = $('.searchbox-icon');
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                var isOpen = false;
                // submitIcon.click(function(){
                    if(isOpen == false){
                        searchBox.addClass('searchbox-open');
                        inputBox.focus();
                        isOpen = true;
                        self.searchOpen = false;
                    } else {
                        searchBox.removeClass('searchbox-open');
                        inputBox.focusout();
                        isOpen = false;
                        self.searchOpen = true;
                    }
                // });  
                submitIcon.mouseup(function(){
                    return false;
                });
                searchBox.mouseup(function(){
                    inputBox.focus();
                    return false;
                });
                $(document).mouseup(function(){
                    if(isOpen == true){
                        $('.searchbox-icon').css('display','block');
                        // submitIcon.click();

                        searchBox.removeClass('searchbox-open');
                        inputBox.focusout();
                        isOpen = false;
                        self.searchOpen = true;
                    }
                });
            },
            searchBoxClose: function() {
                var self = this;
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                searchBox.removeClass('searchbox-open');
                inputBox.focusout();
                self.searchText = "";
                self.searchAPI();
                self.searchOpen = true;
            },
            gotoChatDetailsPage: function(id) {
                var self = this;
                self.$router.push("/chat/detail/" + id);
            },
            mobileResizeViewChatListPage: function() {
                var self = this;
                if (window.innerWidth < 766) {
                    self.isMobileView = true;
                } else {
                    self.isMobileView = false;
                }
            },
            searchAPI:function(flag = null) {

                var self = this;
                var serachURL = (self.searchTab == 'user') ? 'list-user' : 'interacted-customers'

                if(flag == 'forwardChat') {
                    serachURL = 'list-user';
                }

                var fields = {
                    isUserList: (serachURL == 'list-user') ? 'chatUser' : 'chatCustomer',
                    isCustomerList : 'chatCustomer',
                    searchFlag: self.searchTab,
                    searchText: self.searchText,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post(serachURL, fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                if(self.searchTab == 'user') {
                                    self.userArray = response.data.content;
                                } else {
                                    if(flag == 'forwardChat') {
                                        self.userArray = response.data.content;
                                    } else {
                                        self.customerArray = response.data.content;
                                    }
                                    
                                }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });

            },

            tabClick: function(tabValue) {
                var self = this;
                self.searchTab = tabValue;
            },

            sendChatEmail: function() {
                
                var self = this;
                var error = false;
                self.emailChat_error_msg = ""
                if(self.emailChat == '' || self.emailChat == null) {
                    self.emailChat_error_msg = "Email Field is Required.";
                    error = true;
                }

                if (self.emailChat && !self.validEmail(self.emailChat)) {
                    self.emailChat_error_msg = "Enter Valid Email.";
                    error = true;
                }

                if (!error) {

                    var fields = {
                        via: 'email',
                        email: self.emailChat,
                        chatOf: self.toId,
                        fromName: self.userName,
                        forwardTo: '',
                        section: self.section,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    //self.showLoader();
                    HTTP.post("forward-to-user", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    $('#basicModal1').modal('hide');
                                    self.$swal({
                                        title: 'Success',
                                        text: "Chat has been sent Successfully",
                                        type: 'success',
                                        confirmButtonText: 'Ok',
                                        showLoaderOnConfirm: true
                                    });
                                }
                                //self.hideLoader();
                            })
                            .catch(function (error) {
                                $('#basicModal1').modal('hide');
                                //self.hideLoader();
                                self.catchHandler(error, function () {});
                            });

                }
            },

            logoutMobileView: function() {
                EventBus.$emit("logoutMobileSide", true);
            },

            getCustomerDetailsById : function() {
                var self = this;
                if (self.toId != 0 && self.role == 'guest' || self.role == 'Guest') {
                    var fields = {
                        customer_id: self.toId,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    HTTP.post("get-customer-details-by-id", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.customerDetails.name = response.data.content.name;
                                self.customerDetails.email = response.data.content.email;
                                self.customerDetails.phone = response.data.content.phone;
                                self.customerDetails.subject = response.data.content.subject;
                                self.customerDetails.dealership_location = response.data.content.dealership_location;
                            }

                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
                }
            },

            loadCustomer: function() {
                var self = this;
                self.getCustomerDetailsById();
                self.customerCounter = 0;
                self.requestComplete = false;
                var fields = {
                    isCustomerList: 'chatCustomer',
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                // HTTP.post("list-customer", fields, config)
                HTTP.post("interacted-customers", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                // if (response.data.content != "") {
                                    self.customerArray = response.data.content;
                                    self.requestComplete = true;
                                    if(self.customerArray && self.customerArray.length > 0) {
                                        $.each(self.customerArray, function (key, val) {
                                            if(self.customerArray[key].unReadMessageCount > 0 && self.customerArray[key].toId == self.logingId) {
                                                self.customerCounter += 1;
                                            }
                                        });
                                    }

                                self.openChatScreenFromNotification();
                                    // console.log(JSON.stringify(self.customerArray[8]));
                                // }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            // alert(error);
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });
            },

            loadUser: function() {
                var self = this;
                self.requestComplete = false;
                self.userCounter = 0;
                var fields = {
                    isUserList: 'chatUser',
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post("list-user", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                // if (response.data.content != "") {
                                    self.userArray = response.data.content;
                                    self.requestComplete = true;
                                    if(self.userArray && self.userArray.length > 0) {
                                        $.each(self.userArray, function (key, val) {
                                            if(self.userArray[key].toId != null && self.userArray[key].unReadMessageCount > 0 && self.userArray[key].toId == self.logingId) {
                                                self.userCounter += 1;
                                            }
                                        });
                                        // alert(self.userCounter);
                                    }
                                self.openChatScreenFromNotification();
                                // }
                            }
                            //self.hideLoader();
                        })
                        .catch(function (error) {
                            //self.hideLoader();
                            self.catchHandler(error, function () {});
                        });
            },

            chagneStatus: function(statusValue) {
                var self = this;
                EventBus.$emit("changeStatus", statusValue);
                self.status = statusValue
            },

            getMessageHistoryData: function() {
                var self = this;
                self.messageArray = [];
                var fields = {
                    isFrom: '',
                    flag: '',
                    fromdate: '',
                    todate: '',
                    from_id: self.logingId,
                    to_id: self.toId
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("get-messages", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {

                                if (response.data.content != "") {
                                    self.messageArray = response.data.content;
                                    setTimeout(function() {
                                        // $("body").animate({ scrollTop: $(".message-height").height() }, 1000);
                                        $(".message-height").animate({ 
                                            scrollTop: $(".message-height").prop("scrollHeight")
                                        }, 500);
                                    }, 200);
                                }
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },

            getUserChatById: function(id, name, section ,role, email, strSectionRole) {

                var self = this;
                if (self.toId > 0) {
                    self.channel.unbind('client-send-typing-event'+ self.toId + self.logingId);
                }
                self.chatWindow = true;
                self.clickChatFlag = true;

                self.name = name;
                self.section = section;
                self.role = role;
                self.toId = id;
                self.email = email;
                self.strSectionRole = strSectionRole;

                self.getMessageHistoryData();
                self.changeReadCountValue();
                self.broadCastPrivateChannel();

                self.$nextTick(function() {
                    $(".hideShowDiv").hide();
                });
            },
            changeReadCountValue() {
                var self = this;
                var fields = {
                    toId: self.toId,
                    fromId: self.logingId,
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("change-message-count", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.searchBoxClose();
                                self.loadCustomer();
                                self.loadUser();
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },

            sendMessage: function(flag) {
                var self = this;
                self.messageData = self.messageData.trim();
                self.uuid = self.create_UUID();
                //self.messageArray = [];
                var error = false;
                self.message_text_error_msg = "";
                if(flag == 'EndChat') {
                    self.messageData = "Thank you for contacting us.";
                }
                if(!self.messageData && (this.selectedFiles == undefined || !self.selectedFiles.length)) {
                    // Not neccessary to display message if messge input box is empty
                    self.message_text_error_msg = "Message Field is Required.";
                    error = true;
                }
                
                if (!error) {
                    var msg = self.messageData;
                    self.messageData = "";
                    setTimeout(function() {
                        // $("body").animate({ scrollTop: $(".message-height").height() }, 1000);
                        $(".message-height").animate({
                            scrollTop: $(".message-height").prop("scrollHeight")
                        }, 10);
                    }, 200);

                    const fields = new FormData();
                    // fields.append('file', self.selectedFiles);
                    if (this.selectedFiles != undefined){
                        this.selectedFiles.forEach(file => {
                            fields.append('files[]', file);
                        });
                        if (msg == ''){
                            msg = 'File';
                        }
                    }
                    fields.append('toId', self.toId);
                    fields.append('fromId', self.logingId);
                    fields.append('message', msg);
                    fields.append('fromName', self.userName);
                    fields.append('url', '');
                    fields.append('flag',flag);
                    fields.append('uuid', self.uuid);

                    // var fields = {
                    //     toId: self.toId,
                    //     fromId: self.logingId,
                    //     message: msg,
                    //     fromName: self.userName,
                    //     flag: flag,
                    //     url: '',
                    //     uuid : self.uuid,
                    // };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    
                    var date = new Date();
                    /* alert(self.timezone);
                    var sendDate = moment.tz(self.timezone);
                    sendDate = sendDate.format('MMM D, hh:mm A'); */
                    var sendDate = moment(date).format('MMM D, hh:mm A');
                    self.sendFromThisSide = true;
                    self.messageArray.push({
                        flag: flag,
                        message: msg,
                        toId: self.toId,
                        fromName: self.username,
                        fromId: self.logingId,
                        created_date: sendDate,
                        url: "",
                        isFailed: false,
                        uuid : self.uuid,
                    });
                    
                    // self.messageData = "";
                    HTTP.post("send-message", fields, config)
                        .then(function (response) {
                            self.sendFromThisSide = false;
                            if (response.data.code == '200') {
                                
                                if(flag == 'EndChat') {
                                    // alert("You have successfully end chat");
                                    self.$swal({
                                        title: 'Success ',
                                        text: "You have successfully end chat ",
                                        type: 'success',
                                        confirmButtonText: 'Ok ',
                                        showLoaderOnConfirm: true
                                    })
                                }
                                // self.getMessageHistoryData();
                                // self.messageData = '';

                                if (self.fileUploaded){
                                    self.fileUploaded = false;
                                    self.filesPreview = [];
                                    self.selectedFiles = [];
                                    self.getMessageHistoryData();
                                }
                            }
                        })
                        .catch(function (error) {
                            self.sendFromThisSide = false;
                            if(error.response.code == 500) {
                                self.messageArray[self.messageArray.length - 1].isFailed = true;
                            }
                        });
                }
            },
            showSnackBar : function () {
                var x = document.getElementById("snackbar");
                x.className = "show";
                setTimeout(function() {
                    x.className = x.className.replace("show", "");
                }, 6000);
            },

            undoArchiveChat : function () {
                let self = this;
                var fields = {
                    id: self.unArchiveChatId,
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.post("un-archive-chat", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.loadUser();
                            self.loadCustomer();
                            var x = document.getElementById("snackbar");
                            x.className = "show";
                            x.className = x.className.replace("show", "");
                        }

                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    });
            },

            makeArchivedChat: function(id, flag) {
                var self = this;
                self.unArchiveChatId = 0;
                var fields = {
                    id: id,
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("archive-chat", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.clickChatFlag = false;
                                self.unArchiveChatId = id;
                                self.showSnackBar();
                                /*self.$swal({
                                    title: 'Success',
                                    text: response.data.message + " Successfully",
                                    type: 'success',
                                    confirmButtonText: 'Ok',
                                    showLoaderOnConfirm: true
                                })*/
                            }
                            if (flag == "customer") {
                                self.loadCustomer();
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },
            forwardMessage: function() {

                var self = this;
                if(self.radioBtnId > 0) {

                    var fields = {
                        chatOf: self.toId,
                        forwardTo: self.radioBtnId,
                        fromName: self.userName,
                        section: self.section,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    };
                    HTTP.post("forward-to-user", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    $('#basicModal').modal('hide');
                                    self.chatWindow = false;
                                    self.clickChatFlag = false;
                                    self.$swal({
                                        title: 'Success',
                                        text: "Chat has been forwarded Successfully",
                                        type: 'success',
                                        confirmButtonText: 'Ok',
                                        showLoaderOnConfirm: true
                                    }).then((result) => {
                                        if (result.value) {
                                            self.loadCustomer();
                                        }
                                    });
                                }
                            })
                            .catch(function (error) {
                                $('#basicModal').modal('hide');
                                self.catchHandler(error, function () {});
                            });
                } else {
                    // alert("Please Select any One User!");
                    self.$swal({
                        // title: 'Success',
                        text: "Please Select any One User! ",
                        type: 'info',
                        confirmButtonText: 'Ok',
                        showLoaderOnConfirm: true
                    })
                }
                
            },

            broadCast: function() {
                var self = this;
                var pusherKey = 'message-broadcast-channle' + self.logingId;
                var eventKey = 'message-broadcast-event' + self.logingId;

                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {

                    setTimeout(function(){
                        if(data.type == "received") {
                            self.storeReceivedAtDateTime(data.id);
                        }
                        if(self.chatWindow) {
                            if(data.fromId == self.toId) {
                                self.messageArray.push(data);
                                setTimeout(function() {
                                    $(".message-height").animate({
                                        scrollTop: $(".message-height").prop("scrollHeight")
                                    }, 10);
                                }, 200);
                                self.$nextTick(() => {
                                    setTimeout(function() {
                                        self.changeReadCountValue();
                                    }, 100);
                                });
                            } else if (self.checkUUID(self.messageArray, data.uuid) === false
                                        && data.toId == self.toId) {
                                self.messageArray.push(data);
                                setTimeout(function() {
                                    $(".message-height").animate({
                                        scrollTop: $(".message-height").prop("scrollHeight")
                                    }, 10);
                                }, 200);

                                self.$nextTick(() => {
                                    setTimeout(function() {
                                        self.loadCustomer();
                                        self.loadUser();
                                    }, 1500);
                                });
                            } else {
                                self.$nextTick(() => {
                                    setTimeout(function() {
                                        self.loadCustomer();
                                        self.loadUser();
                                    }, 1500);
                                });
                            }
                        } else {
                            self.loadCustomer();
                            self.loadUser();
                        }
                        if(data.toId == self.logingId) {
                            self.$nextTick(() => {
                                self.listenNotification(data);
                            });
                        }
                    },500);
                    
                });

            },

            broadCastStatusChannel: function() {

                var self = this;
                var pusherKey = 'user-status-channel';
                var eventKey = 'user-status-event';

                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {
                    self.loadUser();
                    self.loadCustomer();
                });
            },

            broadCastUserRegisterChannel: function() {

                var self = this;
                var pusherKey = 'user-register-broadcast-channle';
                var eventKey = 'user-register-broadcast-channle';

                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {
                    self.loadUser();
                });
            },

            broadCastForwardChat: function() {

                var self = this;
                var pusherKey = 'forward-customer-broadcast-channle' + self.logingId;
                var eventKey = 'forward-customer-broadcast-event' + self.logingId;

                let fromName, fromId, message;
                var channel = self.pusher.subscribe(pusherKey);
                channel.bind(eventKey, function(data) {
                    fromId = data.fromId;
                    fromName = data.fromName;
                    message = data.message;
                    self.loadCustomer();
                    let messageData = {"fromName" : fromName , "fromId" : fromId, "message" : message};
                    self.$nextTick(() => {
                        self.listenNotification(messageData);
                    });
                });
            },
            storeReceivedAtDateTime: function(messageId) {
                var self = this;
                var fields = {
                    message_id: messageId,
                    received_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                HTTP.post("store-message-receive-date-time", fields, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        });
            },
            listenNotification(messageData) {
                var self = this;
                if(messageData) {
                    var userAgent = navigator.userAgent;
                    var isWeb = false;
                    if(userAgent == 'vvg_chat'){
                        // var searchBar = document.getElementById("fNameMobile");
                    }else{
                        isWeb = true;
                    }

                    if (isWeb) {
                        if (!('Notification' in window)) {
                            console.log('Web Notification is not supported');
                            return;
                        }

                        Notification.requestPermission(permission => {

                            if(permission == 'granted') {
                                const title = messageData.fromName;
                                const options = {
                                    body:  messageData.message,
                                    icon: "/static/images/chat-icon.png",
                                    badge: "/static/images/chat-icon.png",
                                    data: {
                                        fromIdNotification : messageData.fromId
                                    }
                                };
                                var formIdNotification = messageData.fromId;
                                navigator.serviceWorker.getRegistrations().then(
                                    function(registrations) {
                                        if(registrations.length==0) {  
                                            //registration.unregister();
                                            navigator.serviceWorker.register('/static/js/serviceworker.js').then(registration => {
                                    // registration.showNotification(title, options, formIdNotification);
                                })

                                        }
                                        else
                                        {
                                            // registrations[0].showNotification(title, options, formIdNotification);
                                        }
                                });
                                

                            }
                        });
                    }
                    self.playSound();
                }
            },

            //play notification sound
            playSound() {
                // console.log("Play Sound Call");
                var aSound = document.createElement("audio");
                aSound.setAttribute("src", "/static/notification.mp3");
                aSound.play();
            },

            validEmail: function(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.message-failed {
  color: #c9202b;
  font-size: 11px;
  float: right;
  width: 100%;
  text-align: right;
  position: initial;
  padding-top: 5px;
  font-family: "BentonSansRegular", sans-serif;
}

 #snackbar {
     visibility: hidden;
     min-width: 250px;
     margin-left: -125px;
     background-color: #32CD32;
     color: #fff;
     text-align: center;
     border-radius: 2px;
     padding: 16px;
     position: fixed;
     z-index: 1;
     left: 50%;
     bottom: 30px;
     font-size: 17px;
 }

#snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
    from {bottom: 0; opacity: 0;}
    to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
    from {bottom: 30px; opacity: 1;}
    to {bottom: 0; opacity: 0;}
}

.file-upload-container {
  position: relative;
  margin-top: 10px;
}

.drop-zone {
  border: 2px dashed #007bff;
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  background-color: #f7f7f7;
  cursor: pointer;
}

.drop-zone p {
  margin: 0;
  font-size: 14px;
  color: #007bff;
}

.drop-zone.dragover {
  background-color: #e0f0ff;
  border-color: #0056b3;
}

.file-preview {
  margin-top: 10px;
}

.preview-img {
  max-width: 200px; /* Adjust size as needed */
  max-height: 150px; /* Adjust size as needed */
  width: auto;
  height: auto;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.text-preview {
  width: 100%;
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: auto;
}

.file-link {
  display: block;
  margin-top: 10px;
  color: #007bff;
}
.custom-des{
    border: none !important;
    cursor: default !important;
    text-align: left !important;
}
.attachment-icon {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    background-color: #333; /* Icon background color */
    border-radius: 3px; /* Rounded corners */
}

.attachment-icon::before {
    content: '';
    position: absolute;
    top: 6px; /* Adjust as needed */
    left: 6px; /* Adjust as needed */
    width: 12px;
    height: 12px;
    background-color: #fff; /* Inner circle color */
    border-radius: 50%;
}

.attachment-icon::after {
    content: '';
    position: absolute;
    top: 6px; /* Adjust as needed */
    left: 12px; /* Adjust as needed */
    width: 6px;
    height: 6px;
    background-color: #fff; /* Inner line color */
    border-radius: 50%;
    transform: rotate(45deg);
}

</style>


// WEBPACK FOOTER //
// src/components/List/ChatList.vue